import classNames from 'classnames/bind';
import React from 'react';

import Altitude from './Altitude';
import Attitude from './Attitude';
import GPSRaw from './GPSRaw';
import styles from './Monitor.module.scss';

import { Tabs, Vibration } from '@/components/ui/dashboard/Monitor';

const cx = classNames.bind(styles);

const Monitor = ({ robotId }) => {
  return (
    <div className={cx('container')}>
      <Tabs tabs={['Attitude', 'Altitude', 'GPS Raw', 'Vibration']}>
        <Attitude data={robotId} className={cx('attitude')} />
        <Altitude data={robotId} />
        <GPSRaw data={robotId} />
        <Vibration data={robotId} />
      </Tabs>
    </div>
  );
};

export default Monitor;
